import { CardsSlider } from '@widgets/CardsSlider';

export const Cards = () => {
  return (
    <div className='page-animation pt-7.5'>
      <div className='mx-auto w-full max-w-[1294px] px-5'>
        <div className='relative mb-6.5 flex h-[20px] items-center justify-between pl-3 select-none'>
          <div className='relative text-xl font-bold text-[#f2f2f2] uppercase before:absolute before:top-0 before:left-[-10px] before:font-semibold before:text-[#a73f33] before:content-["/"] max-md:text-sm'>
            Cards
          </div>
        </div>

        <CardsSlider animate isVisibleDownloadButton />
      </div>
    </div>
  );
};
